module.exports = __webpack_public_path__ + "static/media/clan_header.161159b6.png";